(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sage-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sage-bread')) {
    customElements.define('sage-bread', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const controls = this.querySelector('.sage-filters');
        if (!controls) return;
        controls.hidden = false;
        controls.addEventListener('click', event => {
          const button = event.target.closest('button[data-filter]');
          if (!button) return;
          controls.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          let count = 0;
          this.querySelectorAll('[data-product]').forEach(card => {
            const matches = button.dataset.filter === 'all' || card.dataset.tags.split(' ').includes(button.dataset.filter);
            card.hidden = !matches;
            if (matches) count++;
          });
          this.querySelector('[data-result-status]').textContent = this.dataset.resultsTemplate.replace('[count]', String(count));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
